export default {"src":"/_next/static/media/bra-flag-rounded-white-border.bb8d2ec9.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};